// src/features/stock/constants/stockConstants.js
export const STOCK_CATEGORIES = [
  { id: 1, name: 'Medications', icon: '💊', color: 'bg-blue-500' },
  { id: 2, name: 'Medical Supplies', icon: '🩺', color: 'bg-green-500' },
  { id: 3, name: 'Equipment', icon: '⚕️', color: 'bg-purple-500' },
  { id: 4, name: 'Laboratory', icon: '🔬', color: 'bg-yellow-500' },
  { id: 5, name: 'Personal Protective', icon: '🛡️', color: 'bg-red-500' },
  { id: 6, name: 'First Aid', icon: '🚑', color: 'bg-orange-500' },
];

export const MOVEMENT_TYPES = {
  IN: { id: 'in', name: 'Stock In', color: 'green' },
  OUT: { id: 'out', name: 'Stock Out', color: 'red' },
  ADJUSTMENT: { id: 'adjustment', name: 'Adjustment', color: 'yellow' },
  RETURN: { id: 'return', name: 'Return', color: 'blue' },
  TRANSFER: { id: 'transfer', name: 'Transfer', color: 'purple' },
  DAMAGED: { id: 'damaged', name: 'Damaged', color: 'orange' },
  EXPIRED: { id: 'expired', name: 'Expired', color: 'gray' },
};

export const STOCK_STATUS = {
  IN_STOCK: { id: 'in_stock', name: 'In Stock', color: 'green' },
  LOW_STOCK: { id: 'low_stock', name: 'Low Stock', color: 'yellow' },
  OUT_OF_STOCK: { id: 'out_of_stock', name: 'Out of Stock', color: 'red' },
  EXPIRED: { id: 'expired', name: 'Expired', color: 'gray' },
  DISCONTINUED: { id: 'discontinued', name: 'Discontinued', color: 'purple' },
};

export const UNITS_OF_MEASURE = [
  { id: 'pcs', name: 'Pieces' },
  { id: 'box', name: 'Box' },
  { id: 'bottle', name: 'Bottle' },
  { id: 'pack', name: 'Pack' },
  { id: 'tablet', name: 'Tablet' },
  { id: 'capsule', name: 'Capsule' },
  { id: 'ml', name: 'Milliliter' },
  { id: 'l', name: 'Liter' },
  { id: 'g', name: 'Gram' },
  { id: 'kg', name: 'Kilogram' },
];

export const STOCK_FILTER_OPTIONS = {
  sortBy: [
    { id: 'name', name: 'Name' },
    { id: 'quantity', name: 'Quantity' },
    { id: 'expiry_date', name: 'Expiry Date' },
    { id: 'created_at', name: 'Date Added' },
  ],
  perPage: [10, 25, 50, 100],
};